import { css } from '@emotion/react';
import { alpha } from '@mui/material/styles';

// Matches the Project Solar demo. A fixed px (not a vh): inside a dynamic-height
// iframe a vh cap feeds back through the parent resize and never settles.
const SLOT_SCROLL_MAX_HEIGHT_PX = 400;

const makeSolarSlotsStyles = ({ theme }) => {
  // The theme's green (aurora's CTA green), so the selected slot tracks the
  // theme rather than a hardcoded colour.
  const green = theme.mvf.palette.component.continueButtonColor;
  const darkGreen = theme.mvf.palette.component.continueButtonHoverColor;

  return {
    container: css({ maxWidth: 640, margin: '0 auto', textAlign: 'left' }),
    backButtonContainer: css({ textAlign: 'left' }),
    backLink: css({
      textTransform: 'none',
      padding: 0,
      color: green,
      fontWeight: theme.mvf.typography.weight.medium,
    }),
    spinner: css({ margin: '10px 0', textAlign: 'center' }),
    heading: css({
      marginTop: 10,
      textAlign: 'left',
      '& h6': {
        fontWeight: 900,
        fontSize: 30,
        lineHeight: 1,
        textAlign: 'left',
      },
    }),
    subheading: css({
      margin: '10px 0 20px 0',
      textAlign: 'left',
      '& p': { textAlign: 'left' },
    }),
    scrollArea: css({
      minHeight: 0,
      maxHeight: SLOT_SCROLL_MAX_HEIGHT_PX,
      overflowY: 'auto',
    }),
    dayGroup: css({ marginBottom: 20 }),
    dayHeader: css({
      margin: '0 0 10px 0',
      paddingBottom: '0.5rem',
      borderBottom: '1px solid rgba(237, 237, 237, 1)',
      textAlign: 'left',
      '& p': {
        fontWeight: theme.mvf.typography.weight.thick,
        color: '#000',
        textAlign: 'left',
      },
    }),
    pillRow: css({
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 150px))',
      gap: 8,
      // Three columns squash the time range onto two lines on a phone, leaving
      // no room for the selected tick. Drop to two columns on small screens.
      '@media (max-width: 540px)': {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
    }),
    pill: css({
      textTransform: 'none',
      borderRadius: '8px',
      border: '2px solid rgba(237, 237, 237, 1)',
      backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      padding: '6px 14px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: 6,
      color: theme.mvf.palette.text.primaryTextColor,
      '&:hover': {
        borderColor: darkGreen,
        backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      },
    }),
    pillSelected: css({
      borderColor: darkGreen,
      backgroundColor: alpha(green, 0.12),
      '&:hover': {
        borderColor: darkGreen,
        backgroundColor: alpha(green, 0.12),
      },
    }),
    tick: css({
      width: 16,
      height: 16,
      borderRadius: '50%',
      backgroundColor: green,
      color: theme.mvf.palette.background.widgetBackgroundColor,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 11,
    }),
    continueContainer: css({
      position: 'sticky',
      bottom: 0,
      zIndex: 2,
      marginTop: 8,
      paddingTop: 12,
      paddingBottom: 4,
      textAlign: 'center',
      backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
    }),
  };
};

export default makeSolarSlotsStyles;
